/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon20Solid = forwardRef('TechPowerButtonIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.25 2a1.25 1.25 0 1 0-2.5 0v7a1.25 1.25 0 0 0 2.5 0V2Z" }),
        React.createElement("path", { d: "M6.304 5.595A1.25 1.25 0 1 0 4.697 3.68a8.25 8.25 0 1 0 10.617.01 1.25 1.25 0 1 0-1.61 1.912 5.75 5.75 0 1 1-7.4-.007Z" })));
});
